var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "opt_g",
      class: { opt_open: this.openedLayer === "time" },
      attrs: { id: "optTime" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.openLayer.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "opt_selected" }, [
        _c("span", { staticClass: "tf_opt" }, [
          _c(
            "span",
            { staticClass: "txt_selected", attrs: { id: "optTimeSelected" } },
            [_vm._v(_vm._s(_vm.timeText[_vm.time]))]
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "txt_desc", attrs: { id: "optTimeDesc" } },
            [_vm._v(_vm._s(_vm.timeDesc))]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "ico_cafetop ico_arrow" }, [
            _vm._v("옵션 더 보기"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.openedLayer === "time",
              expression: "openedLayer === 'time'",
            },
          ],
          staticClass: "opt_layer",
          attrs: { id: "optTime_layer" },
        },
        [
          _c(
            "ul",
            {
              staticClass: "list_opt",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.setTime.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "li",
                {
                  class: { on: _vm.time === "hourly" },
                  attrs: { id: "optTime_hourly" },
                },
                [_vm._v("실시간")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { on: _vm.time === "daily" },
                  attrs: { id: "optTime_daily" },
                },
                [_vm._v("일간")]
              ),
              _vm._v(" "),
              _vm.tab === "cheer"
                ? _c(
                    "li",
                    {
                      class: { on: _vm.time === "weekly" },
                      attrs: { id: "optTime_weekly" },
                    },
                    [_vm._v("주간")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { on: _vm.time === "annually" },
                  attrs: { id: "optTime_annually" },
                },
                [_vm._v("연간")]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }